// extracted by mini-css-extract-plugin
export default {"rowContainer":"Details_rowContainer__B6Oi3","chipContainer":"Details_chipContainer__afzqp"};